var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 58") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9,
    transform: "translate(-17.000000, -58.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-57",
    transform: "translate(17.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-58",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 5.68434189e-14,
    x2: 3,
    y2: 6.9656063,
    id: "\\u8DEF\\u5F84-109"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 11,
    x2: 3,
    y2: 17.9656063,
    id: "\\u8DEF\\u5F84-109\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 6.09484441,
    y2: 10,
    id: "\\u8DEF\\u5F84-110"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 0,
    x2: 17,
    y2: 9,
    id: "\\u8DEF\\u5F84-109"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 13,
    x2: 17,
    y2: 17.9656063,
    id: "\\u8DEF\\u5F84-109\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 20.0948444,
    y2: 12,
    id: "\\u8DEF\\u5F84-110"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 8,
    x2: 10,
    y2: 18,
    id: "\\u8DEF\\u5F84-109",
    transform: "translate(10.000000, 13.000000) scale(1, -1) translate(-10.000000, -13.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 5.9656063,
    id: "\\u8DEF\\u5F84-109\\u5907\\u4EFD",
    transform: "translate(10.000000, 3.000000) scale(1, -1) translate(-10.000000, -3.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 13.0948444,
    y2: 5,
    id: "\\u8DEF\\u5F84-110",
    transform: "translate(10.047422, 5.000000) scale(1, -1) translate(-10.047422, -5.000000) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.189816b97ee343c1f12eae7a5ae43a49.svg";
export { ForwardRef as ReactComponent };